import React from "react";
import { connect } from "react-redux";
import { stationgisApi } from "@api/newApi";
import DropMenu from "./components/DropMenu";
import Progress from "./components/Progress/Progress";
import "./assets/style.scss";
import "./index.scss";

// 是否展示参数配置弹窗
class FactoryProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progressName: "",
      stationId: null,
      list: [],
    };
  }
  async componentDidMount() {
    // 判断路径是否有传递id
    let searchParams = this.props.location.search
      ? this.props.location.search.split("=")
      : null;
    let id = null;
    if (searchParams) {
      id = searchParams[searchParams.length - 1];
    }
    const { userInfo } = this.props;
    const { data: res } = await stationgisApi.selectGisStationList(
      userInfo.stationIds ? userInfo.stationIds.split(",") : []
    );
    const list = [];
    res.forEach((item) => {
      list.push({
        name: item.aliasName,
        id: item.id,
      });
      if (item.id == id) {
        this.setState({
          stationId: item.id,
          progressName: item.aliasName,
        });
      }
    });
    this.setState({
      stationId: list.length > 0 ? list[0].id : undefined,
      progressName: list.length > 0 ? list[0].name : undefined,
      list,
    });
  }
  // 切换厂站
  changeComponent = (progressName) => {
    this.setState({
      stationId: progressName.split("-")[0],
      progressName: progressName.split("-")[1],
    });
  };

  handleSetLoding = (val) => {
    this.setState({
      loading: val,
    });
  };

  render() {
    const { stationId, progressName } = this.state;
    return (
      <div className="factory-progress">
        <DropMenu
          list={this.state.list}
          progressName={progressName}
          changeComponent={this.changeComponent}
        />
        <div className="factory-content">
          <Progress stationId={stationId}></Progress>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(FactoryProgress);
